import { skipToken, useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect, useMemo, useReducer } from 'react';
import {
  reduceExperience,
  restoreState,
} from './useExperienceState.reducer.ts';
import type {
  TExperienceState,
  TExperienceStore,
} from './useExperienceState.types.ts';

export const useExperienceState = (
  projectId: string,
  experienceId: string,
): TExperienceStore => {
  const queryClient = useQueryClient();

  const stateKey = useMemo(
    () => [
      'experiences',
      'state',
      { project_id: projectId, experience_id: experienceId },
    ],
    [projectId, experienceId],
  );

  const { data: storedState } = useQuery<TExperienceState>({
    queryKey: stateKey,
    queryFn: skipToken,
    gcTime: Infinity,
    structuralSharing: false,
    notifyOnChangeProps: [],
  });

  const [state, dispatch] = useReducer(
    reduceExperience,
    storedState,
    restoreState,
  );

  useEffect(() => {
    queryClient.setQueryData(stateKey, state);
  }, [queryClient, stateKey, state]);

  return { state, dispatch };
};
